import { Box, Paper, Typography } from "@mui/material";
import { MessageSquare } from "lucide-react";
import Templete from "../../template/Template";
import ChatList from "./ChatList";

export default function MessageContainer() {
    return (
        <Templete menuActive="whatsapp">
            <Box sx={{ minHeight: '100%' }}>
                <Paper elevation={1}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'center', pt: 2 }}>
                        <MessageSquare size={32} />
                        <Typography variant="h5" component="h1" color="text.primary" fontWeight="bold">
                            Mensagens Enviadas
                        </Typography>
                    </Box>

                    <ChatList />
                </Paper>
            </Box>
        </Templete>
    );
}